import React from 'react';
import { services } from '../../data/services';
import ServiceSection from '../../components/ServiceSection';
import Hero from '../../components/Hero';

const Telefonie = () => {
  const telefonieService = services.find(service => service.title === "Telefonie");

  return (
    <>
      <Hero
        title="Telefonie Fixă și IP"
        subtitle="Comunicare de calitate cu tarife avantajoase"
        variant="compact"
        ctaLabel="Vezi Tarife"
        ctaHref="#tarife"
        backgroundImageUrl="/img/hero-telefonie.jpg"
        icon={telefonieService?.icon}
        iconLabel={telefonieService?.title}
      />

      {telefonieService && (
        <ServiceSection
          service={telefonieService}
          index={0}
          pricingFirst
          id="tarife"
          backgroundImage={false}
          showTitleBlock={false}
        />
      )}
    </>
  );
};

export default Telefonie;
